import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { AppState, useAppDispatch } from '../index';
import { setShowVote, setLanguage, setAddShowVote } from './actions';
import { Client, Account, ServerEventType } from "@amax/amaxup";
import { IUserInfo } from './typings';
import { setUserInfo, AccountStatus } from './actions';
import getAPLinkInfo, { network, getScatter, isAPLink, getClient } from 'common/utils/client';
import { useSleep } from '@/hooks';
import { Storage } from '@/common/utils/storage';
import { login_anchor, login_scatter } from './reducer';
import Server from '@/common/utils/serviceApi';
// export function useBaseToken(): [any[string]] {
//     const baseToken = useSelector<AppState, AppState['base']['baseToken']>((state: AppState) => state.base.baseToken);
//     return [baseToken];
// }

// export function useTokenList(): [any[]] {
//     const dispatch = useAppDispatch();
//     const [baseToken] = useBaseToken();
//     const tokenList = useSelector<AppState, AppState['base']['tokenList']>((state: AppState) => state.base.tokenList);
//     const getTokenList = useCallback(async () => {
//         try {
//             const data: any = await Server.getTokenList();
//             if (data.code === 200) {
//                 const list = [], other = [];
//                 data.data.content.forEach(element => {
//                     if(baseToken.includes(element.coin)){
//                         list.push(element)
//                     }else{
//                         other.push(element)
//                     }
//                 });
//                 dispatch(setTokenList([...list, ...other]));
//             }
//         } catch (e) {
//             console.log('Get Fee TokenList:', e);
//         }
//     }, [dispatch]);

//     useEffect(() => {
//         if (tokenList.length === 5) {
//             getTokenList();
//         }
//     }, []);
//     return [tokenList];
// }

// export function useTokenInfo(): [Record<string,any>] {
//     const tokenInfo = useSelector<AppState, AppState['base']['tokenInfo']>((state: AppState) => state.base.tokenInfo);
//     return [tokenInfo];
// }
// export function useMinAmount(): [Record<string,any>] {
//     const minAmount = useSelector<AppState, AppState['base']['minAmount']>((state: AppState) => state.base.minAmount);
//     return [minAmount];
// }

export function useLogin(): [IUserInfo, () => Promise<any>] {
    const dispatch = useAppDispatch();
    const [sleep] = useSleep(1000);
    const account = useSelector<AppState, AppState['base']['account']>((state: AppState) => state.base.account);

    const login = useCallback(async () => {
        try {
            await sleep();
            //判断amaxup环境
            const client = new Client();
            client.on(ServerEventType.ACCOUNTS_CHANGED, (accounts: Account[]) => {
                // ...
                console.log(accounts,'accounts');
                if (accounts.length) {
                    const {name,publicKey} = accounts[0]
                    localStorage.setItem('walletAddress', name);
                    localStorage.setItem('authority','active');
                    dispatch(
                        setUserInfo({
                            kyc: false,
                            name: name,
                            publicKey: publicKey,
                            status: 1,
                        })
                    );
                }
            })

            if (client.isInIframe()) {
                const account = await client.getAccount()
                console.log(account,'account');
                localStorage.setItem('walletAddress', account.name);
                localStorage.setItem('authority', account.permission);
                dispatch(
                    setUserInfo({
                        kyc: false,
                        name: account.name,
                        publicKey: account.publicKey,
                        status: 1,
                    })
                );
                return false
            }else{
                if ((window as any).armadillo) {
                    console.log('armadillo 登录');
                    const accounts = await (window as any).armadillo.requestAccounts();
                    if (accounts.length) {
                        const {account,publicKey} = accounts[0]
                        localStorage.setItem('walletAddress', account);
                        localStorage.setItem('authority','active');
                        dispatch(
                            setUserInfo({
                                kyc: false,
                                name: account,
                                publicKey: publicKey,
                                status: 1,
                            })
                        );
                    }
                }else{
                    console.log('aplink 登录');
                    const _data = getAPLinkInfo() ? await login_scatter() : await login_anchor()
                    console.log(_data,'_data');
                    const {account, identity} = _data
                    let accountStatus: AccountStatus;
                    // const scatter: any = getScatter();
                    // const identity = await scatter.getIdentity({
                    //     accounts: [{ chainId: network.chainId, blockchain: network.blockchain }],
                    // });

                    // const account = identity?.accounts[0];
                    let publicKey = ''
                    try {
                        const accountData:any = await Server.getPubkeyByAccount(account.name);
                        console.log(accountData,'accountData');
                        publicKey = accountData.permissions[0].required_auth.keys[0].key
                        accountStatus = 1;
                    } catch (e) {
                        console.log(e,'e');
                        publicKey = ''
                        accountStatus = 0;
                    }
                    Storage.setItem('walletAddress',  account.name);
                    Storage.setItem('authority', account.authority);
                    console.log(publicKey,'publicKey');
                    
                    dispatch(
                        setUserInfo({
                            kyc: identity.kyc,
                            name: account.name,
                            publicKey: publicKey,
                            status: accountStatus,
                        })
                    );
                    console.log('----login', identity);
                }
            }

            
        } catch (e) {
            console.error('login Error:', e);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    return [account, login];
}

export function useShowVote(): [boolean, (show: boolean) => void] {
    const dispatch = useAppDispatch();
    const showVote = useSelector<AppState, AppState['base']['showVote']>((state: AppState) => state.base.showVote);
    const handShowVote = (show: boolean) => {
        dispatch(setShowVote(show));
    };
    return [showVote, handShowVote];
}

export function useAddShowVote(): [boolean, (show: boolean) => void] {
    const dispatch = useAppDispatch();
    const showAddVote = useSelector<AppState, AppState['base']['showAddVote']>((state: AppState) => state.base.showAddVote);
    const handAddShowVote = (show: boolean) => {
        dispatch(setAddShowVote(show));
    };
    return [showAddVote, handAddShowVote];
}

export function useLanguage(): [string, (lang: string) => void] {
    const dispatch = useAppDispatch();
    const language = useSelector<AppState, AppState['base']['language']>((state: AppState) => state.base.language);
    const handLanguage = (lang: string) => {
        dispatch(setLanguage(lang));
    };
    return [language, handLanguage];
}
